import NiceModal from "@ebay/nice-modal-react";
import { useNavigate } from "react-router-dom";
import Button from "@components/Button";
import BrandLogo from "@components/BrandLogo";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import { getModuleValue, useWindowSize } from "../../../Helpers";
import TabHighlight from "../img/tab-highlight.webp";
import BonusBgSrc from "./img/bonus.webp";
import "./style.scss";

export default function QrComplete({ activation, resolveData }) {
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const XGA = width >= 1020;
  const heroImageUrl = getModuleValue(activation?.content?.modules, "hero_image", "file.url");

  const points = resolveData?.payout ?? activation?.payout ?? 5;
  const bonusPoints = Math.max(resolveData?.bonus ?? 0, resolveData?.firstBonus ?? 0);
  const isBonus = bonusPoints > 0;
  const brands = activation?.brands ?? [];

  function handleScanAnother() {
    navigate("/qr-scanner-landing");
    NiceModal.show("qr-scanner-modal");
  }

  return (
    <section className="qr-complete">
      <div className="qr-complete__inner">
        <PagesHeader>
          <p><strong>Vuse</strong> Umfrage</p>
        </PagesHeader>
        <div className="qr-complete__body">
          <div className="qr-complete__left">
            {!XGA && heroImageUrl && (
              <div className="qr-complete__mobile-hero">
                {brands.length > 0 && <BrandLogo brands={brands} />}
                <img src={heroImageUrl} alt="" className="qr-complete__mobile-hero-img" />
              </div>
            )}
            <LinearGradientProgressBar value={1} startStepColor="#47B5BF" endStepColor="#008888" />

            <div className="qr-complete__question">
              <p className="qr-complete__desc">
                Danke fürs <strong>Teilen deiner Meinung!</strong>
              </p>
            </div>

            <div className="qr-complete__points-wrap">
              <div className="qr-complete__points-card">
                <div className="qr-complete__points-highlight-clip" aria-hidden="true">
                  <img src={TabHighlight} alt="" className="qr-complete__points-highlight" />
                </div>
                <span className="qr-complete__points-label">Du erhältst:</span>
                <div className="qr-complete__points-badge">
                  <div className="qr-complete__points-badge-wrapper">
                    <span className="qr-complete__points-value">+{points}</span>
                    <span className="qr-complete__points-unit">Punkte</span>
                  </div>
                  {isBonus && (
                    <div className="qr-complete__bonus-badge-wrapper">
                      <img className="qr-complete__bonus-bg" src={BonusBgSrc} alt="" aria-hidden="true" />
                      <div className="qr-complete__bonus-badge-inner">
                        <span className="qr-complete__bonus-value">+{bonusPoints}</span>
                        <span className="qr-complete__bonus-unit">Punkte</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="qr-complete__mobile-buttons">
              <Button href="/qr-scanner-landing" btnClass="ultra-insider outline">Beenden</Button>
              <Button action={handleScanAnother} btnClass="ultra-insider">An weiterer Umfrage teilnehmen</Button>
            </div>
          </div>

          <div className="qr-complete__side">
            {heroImageUrl && (
              <img src={heroImageUrl} alt="" className="qr-complete__side-img" />
            )}
            {brands.length > 0 && <BrandLogo brands={brands} />}
            {XGA && (
              <StickyContent>
                <div className="qr-complete__desktop-buttons">
                  <Button href="/qr-scanner-landing" btnClass="ultra-insider outline">Beenden</Button>
                  <Button action={handleScanAnother} btnClass="ultra-insider">An weiterer Umfrage teilnehmen</Button>
                </div>
              </StickyContent>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
